import { RootState } from "@/app/stores"
import { getPartnerStoresStatistics, IGetPartnerStoresStatistics } from "@/shared/api/partners"
import { ErrorType } from "@/shared/types"
import { createAsyncThunk } from "@reduxjs/toolkit"
import { AxiosError } from "axios"

export const fetchPartnerStoresStatistics = createAsyncThunk<
    IGetPartnerStoresStatistics,
    void,
    { state: RootState }
>('partnerStores/fetchPartnerStoresStatistics', async (_, thunkAPI) => {
    try {
        const { startDate, endDate } = thunkAPI.getState().partnerStores
        const data = await getPartnerStoresStatistics(
            startDate,
            endDate
        )
        return data.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})